"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Guid = void 0;
var _uuid = require("uuid");
var _helpers = require("../analytics/atl-analytics/helpers");
var _random = require("./random");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Guid = exports.Guid = /*#__PURE__*/function () {
  function Guid() {
    _classCallCheck(this, Guid);
  }
  return _createClass(Guid, null, [{
    key: "guid",
    value: function guid() {
      try {
        return (0, _uuid.v4)();
      } catch (e) {
        _helpers.Helpers.sendWrapperLoadError('Error getting uuidV4');
        return (0, _random.mathGuid)();
      }
    }
  }, {
    key: "guidNoDashes",
    value: function guidNoDashes() {
      return (0, _uuid.v4)().replace(/-/g, '');
    }

    /**
     * Convert a GUID deterministically based on the passed in number
     * @param guid - guid to convert
     * @param number - a number to modify the guid by
     * @returns the modified guid or the original in case of failure
     */
  }, {
    key: "addNumberToGUID",
    value: function addNumberToGUID(guid, number) {
      // take the last 4 digits and convert to a hex string representation
      var hex = guid.slice(-4);
      var value = parseInt(hex, 16);
      if (isNaN(value)) {
        return guid;
      }
      var valLength = value.toString(16).length;
      value += number;
      // clamp to 2 bytes
      if (value > 65535) {
        value -= 65536;
      } else if (value < 0) {
        value += 65536;
      }
      // convert back to hex and make sure its as long as many digits as the initial value
      // This is needed for subtraction
      hex = value.toString(16);
      if (hex.length < valLength) {
        hex = ('00000' + hex).slice(-valLength);
      }
      // replace the last 4 digits of the guid with the last 4 digits of the converted value
      return guid.slice(0, guid.length - hex.length) + hex;
    }

    // guidHashCode takes in a String and returns a Number
    // e.g. "51c96b99-f1b0-4727-9802-a40c096929ae" => 411024693
  }, {
    key: "guidHashCode",
    value: function guidHashCode(guid) {
      var hash = 0;
      for (var i = 0; i < guid.length; i++) {
        hash += Math.pow(guid.charCodeAt(i) * 31, guid.length - i);
        hash = hash & hash; // Convert to 32bit integer
      }
      return Math.abs(hash);
    }
  }]);
}();